export default __webpack_public_path__ + "static/81ebcae9d88a67e7b269ef2a63a51a2b.svg";